module.exports = __webpack_public_path__ + "static/media/599.756(6).26b8a383.pdf";